/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Button, Icon, Text, Image } from 'components';
import { ButtonProps } from 'components/Button';

interface UploadAvatarButtonProps extends ButtonProps {
  avatarFilestackId?: string;
  filename?: string;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
}

// TODO: Might be able to actually build this using proper antd components, refactor in the future
const UploadAvatarButton = (props: UploadAvatarButtonProps) => {
  const {
    avatarFilestackId,
    filename,
    onEditClick,
    onDeleteClick,
    ...buttonProps
  } = props;

  const thumbnailUrl = useMemo(
    () => `https://cdn.filestackcontent.com/${avatarFilestackId}`,
    [avatarFilestackId],
  );

  if (avatarFilestackId)
    return (
      <UploadedItem>
        <EditButton onClick={onEditClick}>
          <Thumbnail src={thumbnailUrl} preview={false} />
          {filename || 'image'}
        </EditButton>
        <DeleteButton onClick={onDeleteClick}>
          <Icon type="delete" />
        </DeleteButton>
      </UploadedItem>
    );

  return (
    <StyledButton {...buttonProps}>
      <Icon type="plus" />
      <UploadLabel block>Upload</UploadLabel>
    </StyledButton>
  );
};

export default UploadAvatarButton;

const StyledButton = styled(Button)`
  width: 128px;
  height: 128px;
  border: 1px dashed #d9d9d9;
  border-radius: 2px;
  background-color: #fafafa;
  cursor: pointer;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;

  transition: border-color 0.3s;
  &:hover {
    border-color: #1890ff;
  }
`;

const UploadLabel = styled(Text)`
  /* Antd adds a left margin on a text element after an icon inside a button, we don't want this */
  margin: 8px 0 0 !important;
  opacity: 45%;
`;

const UploadedItem = styled.div`
  width: auto;
  height: 66px;
  padding: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
`;

const EditButton = styled(Button).attrs({
  type: 'link',
})`
  font-weight: 400;
  padding-left: 0;
  padding-right: 0;

  height: 48px;
  display: flex;
  align-items: center;

  overflow: hidden;
  & > span {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  & > .ant-image {
    /* This style doesn't apply when styled on the Thumbnail component, and I don't want to make another container */
    margin-right: 16px;
    flex-shrink: 0;
  }
`;

const Thumbnail = styled(Image).attrs({ width: 48, height: 48 })``;

const DeleteButton = styled(Button).attrs({
  type: 'link',
})``;
